import { Link } from "react-router-dom";
import "./Hero.css";

export default function Hero() {
  return (
    <>
      <section className="hero">
        <div className="container hero__grid">
          <div className="hero__text">
            <p className="hero__eyebrow">
  <img src="/images/star.png" alt="" />
  <span>
    Welcome to Agape Garden Play School
    <br />
    and Day Care
  </span>
</p>
            <h1>
              Build A Foundation <br /> For A Lifetime Learning
            </h1>

            <Link to="/About" className="hero__cta">
              <img src="/images/button.png" alt="Know who we are" />
            </Link>

            <div className="hero__stat">
              <div className="hero__avatars" aria-hidden="true">
                <img src="/images/image-three.png" alt="" />
                <img src="/images/image-two.png" alt="" />
                <img src="/images/image-one.png" alt="" />
              </div>
              <strong>350+</strong>
              <span>
                Happy and <br /> Engaged kids
              </span>
            </div>
          </div>

          <div className="hero__collage">
            <img className="hero__pic hero__pic--1" src="/images/Picture1.png" alt="Two smiling children giving a thumbs up" />
            <img className="hero__pic hero__pic--2" src="/images/Picture2.png" alt="Children building a tower of blocks" />
            <img className="hero__pic hero__pic--3" src="/images/Picture3.png" alt="A child drawing in class" />
          </div>
        </div>
      </section>

      <section className="why">
        <div className="container why__grid">
          <div>
            <h2>
              Why Early Education
              <br /> Matters
            </h2>
            <div className="why__card">
              <h3>The Benefits of Early Education</h3>
              <p>
                High quality early childhood education and care gives children the best start in
                life. It provides important opportunities to learn and develop. Early childhood
                education and care can help your child make friends, develop independence and
                build confidence.
              </p>
              <div className="why__actions">
                <img src="/images/Group.png" alt="" />
                <Link to="/Readmore" className="btn btn--blue">
                  Read more
                </Link>
              </div>
            </div>
          </div>

          <div className="why__art" aria-hidden="true">
            <img className="why__dots" src="/images/circle.png" alt="" />
            <img className="why__photo" src="/images/box-image.png" alt="" />
          </div>
        </div>
      </section>
    </>
  );
}
